var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07421 9.43176C5.27115 9.43176 5.46808 9.35921 5.62356 9.20374L10.1635 4.66383V7.18254C10.1635 7.60751 10.5159 7.95992 10.9409 7.95992C11.3658 7.95992 11.7182 7.60751 11.7182 7.18254V2.78775C11.7182 2.6841 11.6975 2.59081 11.656 2.48716C11.5731 2.30059 11.428 2.14512 11.2311 2.0622C11.1378 2.02074 11.0341 2 10.9305 2H6.53569C6.11072 2 5.75831 2.35241 5.75831 2.77738C5.75831 3.20235 6.11072 3.55476 6.53569 3.55476H9.0544L4.5145 8.09467C4.21392 8.39526 4.21392 8.89278 4.5145 9.19337C4.68034 9.35921 4.87727 9.43176 5.07421 9.43176Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9602 11.7009C14.8255 11.2966 14.3901 11.079 13.9755 11.2137C10.1197 12.499 5.88038 12.499 2.02456 11.2137C1.62033 11.079 1.17463 11.2966 1.03989 11.7009C0.905139 12.1051 1.12281 12.5508 1.52705 12.6856C3.61043 13.38 5.79746 13.7324 7.99486 13.7324C10.1923 13.7324 12.3793 13.38 14.4627 12.6856C14.8773 12.5404 15.0949 12.1051 14.9602 11.7009Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.f37c5cd6d2c708a6258655fd4690763d.svg";
export { ForwardRef as ReactComponent };